import axios from "axios";
import store from '../store/index'
import router from '@/router'

function getToken() {
  return localStorage.token;
}

export const client = axios.create({
  baseURL: process.env.VUE_APP_ROOT_API
});

client.interceptors.request.use(
  config => {
    config.headers.Authorization = `Bearer ${getToken()}`;

    return config;
  },
  error => Promise.reject(error)
);

client.interceptors.response.use(
  config => {
  // Do something before request is sent
  return config;
  }, 
  error => {
    // Do something with request error
    const response = error.response;
    console.error('error.response', response);
    const code = parseInt(error.response && error.response.status)
    if (code === 401) {
      localStorage.removeItem("token")
      router.replace({ name: 'login' })
    }
    return Promise.reject(error);
});

export const RolesRepository = {
  endpoint: "roles",
  getAll() {
    return client.get(this.endpoint);
  }
};

export const UserRepository = {
  endpoint: "users",
  getAll(obj) {
    let query = ''
    if (obj) {
      const currentPage = obj.currentPage ? obj.currentPage : 1
      const perPage = obj.perPage ? obj.perPage : 100
      query = `?page=${currentPage}&perPage=${perPage}`
    }
    return client.get(`${this.endpoint}${query}`);
  },
  get(id) {
    return client.get(`${this.endpoint}/${id}`);
  },
  create(obj) {
    return client.post(this.endpoint, obj);
  },
  update(obj) {
    return client.put(`${this.endpoint}/${obj.id}`, obj);
  },
  delete(id) {
    return client.delete(`${this.endpoint}/${id}`);
  },
  changeOwnPassword(oldPassword, newPassword) {
    return client.put("/change-own-password", {
      oldPassword: oldPassword,
      newPassword: newPassword
    });
  }
};

export const WindFarmRepository = {
  endpoint: "wind-farms",
  getAll(obj) {
    let query = ''
    if (obj) {
      const currentPage = obj.currentPage ? obj.currentPage : 1
      const perPage = obj.perPage ? obj.perPage : 100
      query = `?page=${currentPage}&perPage=${perPage}`
    }
    return client.get(`${this.endpoint}${query}`);
  },
  get(id) {
    return client.get(`${this.endpoint}/${id}`);
  },
  create(obj) {
    return client.post(this.endpoint, obj);
  },
  update(obj) {
    return client.put(`${this.endpoint}/${obj.id}`, obj);
  },
  delete(id) {
    return client.delete(`${this.endpoint}/${id}`);
  },
  changeOwnPassword(oldPassword, newPassword) {
    return client.put("/change-own-password", {
      oldPassword: oldPassword,
      newPassword: newPassword
    });
  },
  windTurbines (obj) {
    return client.get(`${this.endpoint}/${obj.wind_farm_id}/woi-wind-turbines?woi_state_id=${obj.woi_state_id}`);
  }
};

export const WindTurbineTypeRepository = {
  endpoint: "wind-turbine-types",
  getAll() {
    return client.get(this.endpoint);
  }
};

export const WindTurbineBladeTypeRepository = {
  endpoint: "wind-turbine-blade-types",
  getAll() {
    return client.get(this.endpoint);
  }
};

export const ComputerWithAccessRepository = {
  endpoint: "computers-with-access",
  getAll(obj) {
    let query = ''
    if (obj) {
      const currentPage = obj.currentPage ? obj.currentPage : 1
      const perPage = obj.perPage ? obj.perPage : 100
      query = `?page=${currentPage}&perPage=${perPage}`
    }
    return client.get(`${this.endpoint}${query}`);
  },
  get(id) {
    return client.get(`${this.endpoint}/${id}`);
  },
  create(obj) {
    return client.post(this.endpoint, obj);
  },
  update(obj) {
    return client.put(`${this.endpoint}/${obj.id}`, obj);
  },
  delete(id) {
    return client.delete(`${this.endpoint}/${id}`);
  }
};

export const SensorsBoxesRepository = {
  endpoint: "sensors-boxes",
  getAll(obj) {
    let query = ''
    if (obj) {
      // Pagination
      const page = obj.page ? obj.page : 1
      const perPage = obj.perPage ? obj.perPage : 100
      query += `?page=${page}&perPage=${perPage}`
    }
    return client.get(`${this.endpoint}${query}`);
  },
  get(id) {
    return client.get(`${this.endpoint}/${id}`);
  },
  getImages(obj) {
    let query = ''
    if (obj) {
      // Pagination
      const page = obj.page ? obj.page : 1
      const perPage = obj.perPage ? obj.perPage : 100
      query += `?page=${page}&perPage=${perPage}`
      if (obj.date) query += `&date_taken=${obj.date}`
    }
    return client.get(`${this.endpoint}/${obj.id}/images${query}`);
  },
  getData(obj) {
    let query = ''
    if (obj) {
      // Pagination
      const page = obj.page ? obj.page : 1
      const perPage = obj.perPage ? obj.perPage : 100
      query += `?page=${page}&perPage=${perPage}`
      if (obj.date) query += `&date_taken=${obj.date}`
    }
    return client.get(`${this.endpoint}/${obj.id}/data${query}`);
  },
  create(obj) {
    return client.post(this.endpoint, obj);
  },
  update(obj) {
    return client.put(`${this.endpoint}/${obj.id}`, obj);
  },
  delete(id) {
    return client.delete(`${this.endpoint}/${id}`);
  },
};

export const ClientRepository = {
  endpoint: "clients",
  getAll(obj) {
    let query = ''
    if (obj) {
      const currentPage = obj.currentPage ? obj.currentPage : 1
      const perPage = obj.perPage ? obj.perPage : 100
      query = `?page=${currentPage}&perPage=${perPage}`
    }
    return client.get(`${this.endpoint}${query}`);
  },
  get(id) {
    return client.get(`${this.endpoint}/${id}`);
  },
  create(obj) {
    return client.post(this.endpoint, obj);
  },
  update(obj) {
    return client.put(`${this.endpoint}/${obj.id}`, obj);
  },
  delete(id) {
    return client.delete(`${this.endpoint}/${id}`);
  }
};

export const ContractAwardsRepository = {
  endpoint: "contract-awards",
  
  getAll(obj) {
    let query = ''
    if (obj) {
      const currentPage = obj.currentPage ? obj.currentPage : 1
      const perPage = obj.perPage ? obj.perPage : 100
      query = `?page=${currentPage}&perPage=${perPage}`
    }
    return client.get(`${this.endpoint}${query}`);
  },
  get(id) {
    return client.get(`${this.endpoint}/${id}`);
  },
  create(obj) {
    return client.post(this.endpoint, obj);
  },
  update(obj) {
    return client.put(`${this.endpoint}/${obj.id}`, obj);
  },
  delete(id) {
    return client.delete(`${this.endpoint}/${id}`);
  }
};

export const WorkOrdersRepository = {
  endpoint: "work-orders",
  getAll(obj) {
    let query = ''
    if (obj) {
      // Pagination
      const page = obj.page ? obj.page : 1
      const perPage = obj.perPage ? obj.perPage : 100
      query += `?page=${page}&perPage=${perPage}`
      // With
      if (obj.with) query += `&with=${obj.with}`
      // Sort
      if (obj.sortBy) query += `&sortBy=${obj.sortBy}`
      if (obj.sortType) query += `&sortType=${obj.sortType}`
      // Filter
      if (obj.filters) {
        const filters = Object.keys(obj.filters)
        for (let i=0; i < filters.length; i++) {
          const filter = filters[i]
          const value = obj.filters[filter]
          if (value) query += `&${filter}=${value}`
        }
      }
    }
    return client.get(`${this.endpoint}${query}`);
  },
  get(obj) {
    let query = ''
    if (obj.with) query = `?with=${obj.with}`
    return client.get(`${this.endpoint}/${obj.id}${query}`);
  },
  getInterventions(obj) {
    let query = ''
    if (obj.with) query = `?with=${obj.with}`
    return client.get(`${this.endpoint}/${obj.id}/interventions${query}`);
  },
  create(obj) {
    return client.post(this.endpoint, obj);
  },
  update(obj) {
    delete obj.hash
    return client.put(`${this.endpoint}/${obj.id}`, obj);
  },
  delete(id) {
    return client.delete(`${this.endpoint}/${id}`);
  },
  uploadFile(obj) {
    return client.post(`${this.endpoint}/${obj.id}/file`, obj.file, {
      onUploadProgress: uploadEvent => {
        let upload = uploadEvent.loaded / uploadEvent.total
        store.commit('uploading', upload)
      }
    });
  },
  deleteFile(obj) {
    return client.delete(`${this.endpoint}/${obj.work_order_id}/file/${obj.id}`);
  }
};

export const WorkInterventionsRepository = {
  endpoint: "work-interventions",
  endpoint1: "work-orders",
  endpoint2: "interventions",
  getAll(obj) {
    let query = ''
    if (obj) {
      // Pagination
      const page = obj.page ? obj.page : 1
      const perPage = obj.perPage ? obj.perPage : 100
      query = `?page=${page}&perPage=${perPage}`
      // With
      if (obj.with) query += `&with=${obj.with}`
      // Sort
      if (obj.sortBy) query += `&sortBy=${obj.sortBy}`
      if (obj.sortType) query += `&sortType=${obj.sortType}`
      // Filter
      if (obj.filters) {
        const filters = Object.keys(obj.filters)
        for (let i=0; i < filters.length; i++) {
          const filter = filters[i]
          const value = obj.filters[filter]
          if (value) query += `&${filter}=${value}`
        }
      }
    }
    return client.get(`${this.endpoint}${query}`);
  },
  get(obj) {
    // With
    let query = ''
    if (obj.with) query += `?with=${obj.with}`
    return client.get(`${this.endpoint1}/${obj.work_order_id}/${this.endpoint2}/${obj.id}${query}`);
  },
  create(obj) {
    let query = ''
    if (obj.with) query = `?with=${obj.with}`
    return client.post(`${this.endpoint1}/${obj.work_order_id}/${this.endpoint2}${query}`, obj);
  },
  update(obj) {
    return client.patch(`${this.endpoint1}/${obj.work_order_id}/${this.endpoint2}/${obj.id}`);
  },
  changeState(obj) {
    return client.put(`${this.endpoint}-state/${obj.id}`, obj);
  },
  delete(obj) {
    return client.delete(`${this.endpoint1}/${obj.work_order_id}/${this.endpoint2}/${obj.id}`);
  }
};

export const WorkInterventionsPanoramicRepository = {
  endpoint: "work-intervention-panoramic",
  uploadFile(obj) {
    return client.post(`${this.endpoint}/${obj.id}/file`, obj.file, {
      onUploadProgress: uploadEvent => {
        let upload = uploadEvent.loaded / uploadEvent.total
        store.commit('uploading', upload)
      }
    });
  },
  deleteFile(obj) {
    return client.delete(`${this.endpoint}/${obj.blade_panoramic_image_id}/file/${obj.id}`);
  }
};

export const WorkInterventionDaysRepository = {
  work_orders: "work-orders",
  interventions: "interventions",
  days: "days",
  getAll(obj) {
    // With
    let query = ''
    if (obj.with) query += `?with=${obj.with}`
    return client.get(`${this.work_orders}/${obj.work_order_id}/${this.interventions}/${obj.work_intervention_id}/${this.days}${query}`);
  },
  get(obj) {
    // With
    let query = ''
    if (obj.with) query += `?with=${obj.with}`
    return client.get(`${this.work_orders}/${obj.work_order_id}/${this.interventions}/${obj.work_intervention_id}/${this.days}/${obj.id}${query}`);
  },
  create(obj) {
    return client.post(`${this.work_orders}/${obj.work_order_id}/${this.interventions}/${obj.work_intervention_id}/${this.days}`, obj);
  },
  update(obj) {
    delete obj.hash
    return client.put(`${this.work_orders}/${obj.work_order_id}/${this.interventions}/${obj.work_intervention_id}/${this.days}/${obj.id}`, obj);
  },
  delete(obj) {
    return client.delete(`${this.work_orders}/${obj.work_order_id}/${this.interventions}/${obj.work_intervention_id}/${this.days}/${obj.id}`);
  }
};

export const WorkBlocksRepository = {
  endpoint: "work-blocks",
  getAll() {
    return client.get(`${this.endpoint}`);
  },
  get(id) {
    return client.get(`${this.endpoint}/${id}`);
  },
  create(obj) {
    return client.post(this.endpoint, obj);
  },
  update(obj) {
    return client.put(`${this.endpoint}/${obj.id}`, obj);
  },
  delete(id) {
    return client.delete(`${this.endpoint}/${id}`);
  }
};

export const ShutDownBlocksRepository = {
  endpoint: "wind-turbine-shut-down-blocks",
  getAll(obj) {
    let query = ''
    if (obj) {
      const currentPage = obj.currentPage ? obj.currentPage : 1
      const perPage = obj.perPage ? obj.perPage : 100
      query = `?page=${currentPage}&perPage=${perPage}`
    }
    return client.get(`${this.endpoint}${query}`);
  },
  get(id) {
    return client.get(`${this.endpoint}/${id}`);
  },
  create(obj) {
    return client.post(this.endpoint, obj);
  },
  update(obj) {
    return client.put(`${this.endpoint}/${obj.id}`, obj);
  },
  delete(id) {
    return client.delete(`${this.endpoint}/${id}`);
  }
};

export const TimeWorkedPerDamagePerDayRepository = {
  endpoint: "time-worked-per-damage-per-days",
  getAll(obj) {
    let query = ''
    if (obj) {
      const currentPage = obj.currentPage ? obj.currentPage : 1
      const perPage = obj.perPage ? obj.perPage : 100
      query = `?page=${currentPage}&perPage=${perPage}`
    }
    return client.get(`${this.endpoint}${query}`);
  },
  get(id) {
    return client.get(`${this.endpoint}/${id}`);
  },
  create(obj) {
    return client.post(this.endpoint, obj);
  },
  update(obj) {
    return client.put(`${this.endpoint}/${obj.id}`, obj);
  },
  delete(id) {
    return client.delete(`${this.endpoint}/${id}`);
  }
};

export const UsedMaterialsRepository = {
  endpoint: "used-materials",
  getAll(obj) {
    let query = ''
    if (obj) {
      const currentPage = obj.currentPage ? obj.currentPage : 1
      const perPage = obj.perPage ? obj.perPage : 100
      query = `?page=${currentPage}&perPage=${perPage}`
    }
    return client.get(`${this.endpoint}${query}`);
  },
  get(id) {
    return client.get(`${this.endpoint}/${id}`);
  },
  create(obj) {
    return client.post(this.endpoint, obj);
  },
  update(obj) {
    return client.put(`${this.endpoint}/${obj.id}`, obj);
  },
  delete(id) {
    return client.delete(`${this.endpoint}/${id}`);
  }
};

export const UsedSparePartsRepository = {
  endpoint: "used-spare-parts",
  getAll(obj) {
    let query = ''
    if (obj) {
      const currentPage = obj.currentPage ? obj.currentPage : 1
      const perPage = obj.perPage ? obj.perPage : 100
      query = `?page=${currentPage}&perPage=${perPage}`
    }
    return client.get(`${this.endpoint}${query}`);
  },
  get(id) {
    return client.get(`${this.endpoint}/${id}`);
  },
  create(obj) {
    return client.post(this.endpoint, obj);
  },
  update(obj) {
    return client.put(`${this.endpoint}/${obj.id}`, obj);
  },
  delete(id) {
    return client.delete(`${this.endpoint}/${id}`);
  }
};

export const GeneratedWastesRepository = {
  endpoint: "generate-wastes",
  getAll(obj) {
    let query = ''
    if (obj) {
      const currentPage = obj.currentPage ? obj.currentPage : 1
      const perPage = obj.perPage ? obj.perPage : 100
      query = `?page=${currentPage}&perPage=${perPage}`
    }
    return client.get(`${this.endpoint}${query}`);
  },
  get(id) {
    return client.get(`${this.endpoint}/${id}`);
  },
  create(obj) {
    return client.post(this.endpoint, obj);
  },
  update(obj) {
    return client.put(`${this.endpoint}/${obj.id}`, obj);
  },
  delete(id) {
    return client.delete(`${this.endpoint}/${id}`);
  }
};

export const RepairStagesRepository = {
  endpoint: "repair-stages",
  work_orders: "work-orders",
  interventions: "interventions",
  damages: "damages",
  stages: "stages",
  getAll(obj) {
    let query = ''
    if (obj && obj.damage) query += `?damage_id=${obj.damage}`
    return client.get(`${this.endpoint}${query}`);
  },
  get(id) {
    return client.get(`${this.endpoint}/${id}`);
  },
  create(obj) {
    return client.post(this.endpoint, obj);
  },
  update(obj) {
    delete obj.hash
    return client.put(`${this.endpoint}/${obj.id}`, obj);
  },
  delete(id) {
    return client.delete(`${this.endpoint}/${id}`);
  },
  getInterventionFiles(obj) {
    return client.get(`${this.work_orders}/${obj.work_order_id}/${this.interventions}/${obj.work_intervention_id}/repair-stage-images`);
  },
  getFiles(obj) {
    // With
    let query = ''
    if (obj.with) query += `?with=${obj.with}`
    return client.get(`${this.work_orders}/${obj.work_order_id}/${this.interventions}/${obj.work_intervention_id}/${this.damages}/${obj.blade_damage_id}/${this.stages}/${obj.repair_stage_id}${query}`);
  },
  uploadFile(obj) {
    return client.post(`${this.work_orders}/${obj.work_order_id}/${this.interventions}/${obj.work_intervention_id}/${this.damages}/${obj.blade_damage_id}/${this.stages}/${obj.repair_stage_id}/files`, obj.file, {
      onUploadProgress: uploadEvent => {
        let upload = uploadEvent.loaded / uploadEvent.total
        store.commit('uploading', upload)
      }
    });
  },
  deleteFile(obj) {
    return client.delete(`${this.work_orders}/${obj.work_order_id}/${this.interventions}/${obj.work_intervention_id}/${this.damages}/${obj.blade_damage_id}/${this.stages}/${obj.repair_stage_id}/files/${obj.id}`);
  }
};

export const RepairStagesImagesRepository = {
  endpoint: "repair-stage-images",
  work_orders: "work-orders",
  interventions: "interventions",
  damages: "damages",
  stages: "stages",
  getAll(obj) {
    return client.get(`${this.work_orders}/${obj.work_order_id}/${this.interventions}/${obj.work_intervention_id}/repair-stage-images`);
  },
  get(obj) {
    // With
    let query = ''
    if (obj.with) query += `?with=${obj.with}`
    return client.get(`${this.work_orders}/${obj.work_order_id}/${this.interventions}/${obj.work_intervention_id}/${this.damages}/${obj.blade_damage_id}/${this.stages}/${obj.repair_stage_id}${query}`);
  },
};

export const BladePanoramicImagesRepository = {
  endpoint: "blade-panoramic-images",
  getAll(obj) {
    let query = ''
    if (obj && obj.work_intervention_id) query += `?work_intervention_id=${obj.work_intervention_id}`
    return client.get(`${this.endpoint}${query}`);
  },
  get(id) {
    return client.get(`${this.endpoint}/${id}`);
  },
  create(obj) {
    return client.post(this.endpoint, obj);
  },
  update(obj) {
    delete obj.hash
    return client.put(`${this.endpoint}/${obj.id}`, obj);
  },
  delete(id) {
    return client.delete(`${this.endpoint}/${id}`);
  }
};

export const BladeDamageIsInBladeZonesRepository = {
  endpoint: "blade-damage-is-in-blade-zones",
  getAll(obj) {
    let query = ''
    if (obj) {
      const currentPage = obj.currentPage ? obj.currentPage : 1
      const perPage = obj.perPage ? obj.perPage : 100
      query = `?page=${currentPage}&perPage=${perPage}`
    }
    return client.get(`${this.endpoint}${query}`);
  },
  get(id) {
    return client.get(`${this.endpoint}/${id}`);
  },
  create(obj) {
    return client.post(this.endpoint, obj);
  },
  update(obj) {
    return client.put(`${this.endpoint}/${obj.id}`, obj);
  },
  delete(id) {
    return client.delete(`${this.endpoint}/${id}`);
  }
};

export const BladeZonesRepository = {
  endpoint: "blade-zones",
  getAll(obj) {
    let query = ''
    if (obj) {
      const currentPage = obj.currentPage ? obj.currentPage : 1
      const perPage = obj.perPage ? obj.perPage : 100
      query = `?page=${currentPage}&perPage=${perPage}`
    }
    return client.get(`${this.endpoint}${query}`);
  },
  get(id) {
    return client.get(`${this.endpoint}/${id}`);
  },
  create(obj) {
    return client.post(this.endpoint, obj);
  },
  update(obj) {
    return client.put(`${this.endpoint}/${obj.id}`, obj);
  },
  delete(id) {
    return client.delete(`${this.endpoint}/${id}`);
  }
};

export const BladeDamagesRepository = {
  work_orders: "work-orders",
  interventions: "interventions",
  damages: "damages",
  getAll(obj) {
    // With
    let query = ''
    if (obj.with) query += `?with=${obj.with}`
    if (obj.wind_turbine) query += `&wind_turbine=${obj.wind_turbine}` 
    return client.get(`${this.work_orders}/${obj.work_order_id}/${this.interventions}/${obj.work_intervention_id}/${this.damages}${query}`);
  },
  get(obj) {
    // With
    let query = ''
    if (obj.with) query += `?with=${obj.with}`
    return client.get(`${this.work_orders}/${obj.work_order_id}/${this.interventions}/${obj.work_intervention_id}/${this.damages}/${obj.id}${query}`);
  },
  create(obj) {
    return client.post(`${this.work_orders}/${obj.work_order_id}/${this.interventions}/${obj.work_intervention_id}/${this.damages}`, obj);
  },
  update(obj) {
    delete obj.hash
    return client.put(`${this.work_orders}/${obj.work_order_id}/${this.interventions}/${obj.work_intervention_id}/${this.damages}/${obj.id}`, obj);
  },
  delete(obj) {
    return client.delete(`${this.work_orders}/${obj.work_order_id}/${this.interventions}/${obj.work_intervention_id}/${this.damages}/${obj.id}`);
  },
  uploadFile(obj) {
    return client.post(`${this.work_orders}/${obj.work_order_id}/${this.interventions}/${obj.work_intervention_id}/${this.damages}/${obj.id}/files`, obj.file, {
      onUploadProgress: uploadEvent => {
        let upload = uploadEvent.loaded / uploadEvent.total
        store.commit('uploading', upload)
      }
    });
  },
  deleteFile(obj) {
    return client.delete(`${this.work_orders}/${obj.work_order_id}/${this.interventions}/${obj.work_intervention_id}/${this.damages}/${obj.blade_damage_id}/files/${obj.id}`);
  }
};

export const BladeDamageSimilarsRepository = {
  work_orders: 'work-orders',
  damage_similars: "damage-similars",
  getAllDamages(obj) {
    let query = ''
    // With
    if (obj && obj.with) query += `?with=${obj.with}`
    return client.get(`${this.work_orders}/${obj.work_order_id}/damages${query}`);
  },
  getAll(obj) {
    let query = ''
    // With
    if (obj && obj.with) query += `?with=${obj.with}`
    return client.get(`${this.work_orders}/${obj.work_order_id}/${this.damage_similars}${query}`);
  },
  create(obj) {
    return client.post(`${this.work_orders}/${obj.work_order_id}/${this.damage_similars}`, obj);
  },
  delete(obj) {
    return client.delete(`${this.work_orders}/${obj.work_order_id}/${this.damage_similars}/${obj.id}`);
  }
};

export const ReportsGenerationRepository = {
  reports: 'reports-generation',
  work_orders: 'work-orders',
  wind_turbine_work_order_reports: 'wind-turbine-work-order-reports',
  getAll(obj) {
    let query = ''
    if (obj) {
      // Pagination
      const page = obj.page ? obj.page : 1
      const perPage = obj.perPage ? obj.perPage : 100
      query += `?page=${page}&perPage=${perPage}`
      // With
      if (obj.with) query += `&with=${obj.with}`
      // Sort
      if (obj.sortBy) query += `&sortBy=${obj.sortBy}`
      if (obj.sortType) query += `&sortType=${obj.sortType}`
      // Filter
      if (obj.filters) {
        const filters = Object.keys(obj.filters)
        for (let i=0; i < filters.length; i++) {
          const filter = filters[i]
          const value = obj.filters[filter]
          if (value) query += `&${filter}=${value}`
        }
      }
    }
    return client.get(`${this.reports}/${this.wind_turbine_work_order_reports}${query}`);
  },
  get(obj) {
    return client.get(`${this.reports}/${this.wind_turbine_work_order_reports}/${obj.id}`);
  },
  create(obj) {
    return client.post(`${this.reports}/${this.wind_turbine_work_order_reports}`, obj);
  },
  createVersion(obj) {
    const report_id = obj.id
    delete obj.id
    return client.post(`${this.reports}/${this.wind_turbine_work_order_reports}/${report_id}/versions`, obj);
  },
  delete(obj) {
    return client.delete(`${this.reports}/${this.wind_turbine_work_order_reports}/${obj.report_id}`);
  },
  deleteVersion(obj) {
    return client.delete(`${this.reports}/${this.wind_turbine_work_order_reports}/${obj.report_id}/versions/${obj.version_id}`);
  },
  preview(obj) {
    let report_id = ''
    if (obj.id) {
      report_id = `${obj.id}/`
      delete obj.id
    }
    return client.post(`${this.reports}/${this.wind_turbine_work_order_reports}/${report_id}preview`, obj);
  },
  workOrders(obj) {
    let query = ''
    if (obj.work_type_id) query += `?work_type_id=${obj.work_type_id}`
    return client.get(`${this.reports}/${this.work_orders}/get-elegible-for-report-generation${query}`);
  },
  windFarms(obj) {
    return client.get(`${this.reports}/${this.work_orders}/${obj.work_order_id}/wind-farms-elegible-for-report-generation`);
  },
  windTurbines(obj) {
    return client.get(`${this.reports}/${this.work_orders}/${obj.work_order_id}/wind-farms/${obj.wind_farm_id}/wind-turbines-elegible-for-report-generation`);
  },
  interventions(obj) {
    let query = `?wind_turbine=${obj.wind_turbine}`
    // With
    if (obj.with) query += `&with=${obj.with}`
    return client.get(`${this.reports}/${this.work_orders}/${obj.work_order_id}/wind-farms/${obj.wind_farm_id}/interventions-elegible-for-report-generation${query}`);
  },
};

export const ReportsRepository = {
  damages_info: 'damages-info',
  work_blocks: 'work-blocks',
  materials_used: 'materials-used',
  waste_generated: 'waste-generated',
  getAll(obj) {
    const endpoint = this[obj.endpoint]
    let query = ''
    if (obj) {
      // Pagination
      const page = obj.page ? obj.page : 1
      const perPage = obj.perPage ? obj.perPage : 100
      query += `?page=${page}&perPage=${perPage}`
      // With
      if (obj.with) query += `&with=${obj.with}`
      // Sort
      if (obj.sortBy) query += `&sortBy=${obj.sortBy}`
      if (obj.sortType) query += `&sortType=${obj.sortType}`
      // Filter
      if (obj.filters) {
        const filters = Object.keys(obj.filters)
        for (let i=0; i < filters.length; i++) {
          const filter = filters[i]
          const value = obj.filters[filter]
          if (value) query += `&${filter}=${value}`
        }
      }
    }
    return client.get(`reports/${endpoint}${query}`);
  },
}